import React, { useState } from 'react';
import './App.css';
import Background from './components/Background';
import ProfileHeader from './components/ProfileHeader';
import CardsGrid from './components/CardsGrid';
import TiltMode from './components/TiltMode';
import TableauPage from './components/TableauPage';

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 2;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="App">
      <Background />
      
      {/* Contenu conditionnel */}
      {currentSlide === 0 ? (
        <main className="main-container">
          <section className="hero-section">
            <ProfileHeader onNavigate={goToSlide} />
            
          </section>
          <CardsGrid />
          <TiltMode />
        </main>
      ) : (
        <TableauPage onNavigate={goToSlide} />
      )}
    </div>
  );
}

export default App;
